module.exports = [
    {
      path: '/symptom',
      component: true,
      redirect: '/symptom/list',
      name: '症状管理',
      children: [
        {
          path: 'list',
          name: '列表',
          component: () => import('@/views/symptom/list'),
        },
        {
          path: 'form',
          name: '表单',
          component: () => import('@/views/symptom/form'),
        },
        {
          path: 'relate',
          name: '关联问题',
          component: () => import('@/views/symptom/relate'),
        }
      ]
    },
  ]


// WEBPACK FOOTER //
// ./src/router/symptom.js